import React, { ReactNode, useCallback } from "react";
import { Typography } from "@mui/material";

export interface IPromptBannerProps {
    id?: string;
    className?: string;
    onHide: () => void;
    children: ReactNode;
}

export const PromptBanner = (props: IPromptBannerProps) => {
    const handleEnterAnimationEnd = useCallback((event: React.AnimationEvent<HTMLElement>) =>
        event.currentTarget.dataset.animationStage = "leave", []);
    const handleLeaveAnimationEnd = useCallback(() => props.onHide(), []);
    const handleAnimationEnd = useCallback((event: React.AnimationEvent<HTMLElement>) =>
        event.currentTarget.dataset.animationStage === "enter" ?
            handleEnterAnimationEnd(event) : handleLeaveAnimationEnd(),
        []);

    return <Typography key={`par-${props.id}`} className={`${props.className}`} onAnimationEnd={handleAnimationEnd} data-animation-stage={"enter"}>
        {props.children}
    </Typography>;
};
